// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

//import { CountUp } from 'countup.js';



import Splide from '@splidejs/splide';

const splideProject = new Splide( '#splide-project', {
	perPage: 1,
  arrows: false,
  pagination: true,
  autoHeight: false,

  classes: {
		// Add classes for arrows.
		// arrows: 'splide__arrows your-class-arrows',
		// arrow : 'splide__arrow your-class-arrow',
		// prev  : 'splide__arrow--prev your-class-prev',
		// next  : 'splide__arrow--next your-class-next',
		
		// Add classes for pagination.
		pagination: 'splide__pagination slide-project-grid', // container
		page      : 'splide__pagination__page w-4 h-4 block border rounded-full', // each button
	},



} ).mount();



if ( splideProject.length >= 1 ) {

	const getPagination = document.querySelector('.slide-project-grid > li');
   
	getPagination.style.display = 'none'; 
   
   }

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	// Home page
	home,
	// About Us page, note the change from about-us to aboutUs.
	aboutUs,
  });
  
  // Load Events
  jQuery(document).ready(() => routes.loadEvents());